import React from 'react';
import { Box } from '@mui/material';

export const MapMenuPanelContainer = ({ children, ...rest }) => (
  <Box
    {...rest}
    sx={{
      minWidth: 250,
      maxWidth: 350,
      maxHeight: 'calc(100vh - 70px)',
      position: 'absolute',
      top: 70,
      right: 10,
      zIndex: 5,
      display: 'grid',
      gridAutoFlow: 'row',
      overflow: 'scroll',
    }}
  >
    {children}
  </Box>
);
